module.exports = __webpack_public_path__ + "assets/ATrByCircumcenterDetailed.0f0ab9c11fdaad23c1d08516e6917123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/ATrByCircumcenterDetailed.png
// module id = 456
// module chunks = 0